import { KatTableRow } from "@amzn/katal-react";
import classnames from "classnames";
import React, { type FC } from "react";
import type { ColumnDefinition } from "src/components/DataTable/DataTableDefinition";
import type { DataTableRowProps } from "src/components/DataTable/DataTableRow";

import styles from "../../../../../../../styles.module.scss";
import DataTableCell from "../../../../../../DataTable/DataTableCell";

const PhysicalReceiptTableRow: FC<DataTableRowProps<any>> = ({
  id,
  content,
  contents,
  columnsDefinition,
}) => {
  const buildTableCell = (
    columnDefinition: ColumnDefinition,
    index: number
  ) => (
    <DataTableCell
      key={`${id}-data-table-cell-${columnDefinition.property}-${index}`}
      id={id}
      columnDefinition={columnDefinition}
      content={content}
      contents={contents}
    />
  );

  const isDiscrepant = content.EXPECTED !== content.RECEIVED;

  return (
    <KatTableRow
      id={`${id}-data-table-row`}
      className={classnames({
        [styles.background_error_red]: isDiscrepant,
      })}
    >
      {columnsDefinition.map((columnDefinition, index) =>
        buildTableCell(columnDefinition, index)
      )}
    </KatTableRow>
  );
};

export default PhysicalReceiptTableRow;
